import React from 'react';
import { Col, Row } from 'react-bootstrap';
import SideBar from '../Common/sidebar';
import { demoProfile } from './marketingDemoData';
import '../Dashboard/Header/HeaderDashboard.css';

/** V1 mobile header shell — logo + burger menu (same classes as HeaderDashboard). */
const MarketingMobileHeader = () => (
    <Row className="HeaderDashboard" style={{ margin: 0 }}>
        <Col xs={6}>
            <div
                className="Oola-Logo Black-Logo"
                style={{ cursor: 'default' }}
                aria-label="Oola Life"
            />
        </Col>
        <Col
            xs={6}
            style={{
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingRight: '2%',
                textAlign: '-webkit-right',
            }}
        >
            <div
                className="menuMobile"
                style={{
                    cursor: 'default',
                    backgroundColor: '#FFF',
                    border: '0px',
                }}
                aria-hidden="true"
            >
                <SideBar
                    profile={demoProfile}
                    logOutHandler={() => {}}
                    disableTimeModal={false}
                />
            </div>
        </Col>
    </Row>
);

export default MarketingMobileHeader;
